export enum MENU_ITEM_CODE {
  HOME = 'home',

  /** Calendar - Lịch cơ quan */
  CALENDAR = 'calendar',
  MENU_WORK_SCHEDULE = 'menu__WORK_SCHEDULE',
  PERMISSION_WORK_SCHEDULE = 'permission__WORK_SCHEDULE',

  /** Document - Văn bản */
  DOCUMENT = 'document',
  MENU_CHILD_DOCUMENT = 'menu_child__DOCUMENT',
  MENU_LIEN_THONG_DOCUMENT = 'menu_lien_thong__DOCUMENT',
  MENU_UBQLV_DOCUMENT = 'menu_ubqlv__DOCUMENT',
  MENU_ADMIN_DOCUMENT = 'menu_admin__DOCUMENT',
  MENU_PERMISSION_DOCUMENT = 'menu_permission__DOCUMENT',

  /** Mission - Nhiệm vụ */
  MISSION = 'mission',
  MENU_MISSION = 'menu__MISSION',
  LANH_DAO_MISSION = 'lanh_dao__MISSION',
  PERMISSION_MISSION = 'permission__MISSION',

  /** Work - Công việc */
  WORK = 'work',
  MENU_WORK = 'menu__WORK',
  MENU_QUY_TRINH_MUA_SAM = 'menu__QUY_TRINH_MUA_SAM',
  PERMISSION_WORK = 'permission__WORK',

  /** Salary - Bảng lương */
  SALARY = 'salary',
  MENU_SALARY = 'menu__SALARY',
  MENU_MY_SALARY = 'menu__MY_SALARY',
  PERMISSION_SALARY = 'permission__SALARY',

  /** Proposal - Hành chính */
  PROPOSAL = 'proposal',
  MENU_PROPOSAL = 'menu__PROPOSAL',
  MENU_PHAN_PHAT = 'menu__PHAN_PHAT',
  PERMISSION_PROPOSAL = 'permission_PROPOSAL',
  SUB_MENU_QUAN_LY_KHO = 'sub_menu__QUAN_LY_KHO',
  MENU_PROPOSAL_ADVANCE = 'menu__PROPOSAL_ADVANCE',
  ADMINISTRATION_PROPOSAL = 'administration_PROPOSAL',

  /** Risk - Kiểm soát rủi ro */
  RISK = 'risk',
  MENU_PKS_RUI_RO = 'menu__PKS_RUI_RO',
  BAOCAO_PKS_RUI_RO = 'baoCao__PKS_RUI_RO',
  QUANTRI_PKS_RUI_RO = 'quanTri__PKS_RUI_RO',
  PERMISSION_PKS_RUI_RO = 'permission__PKS_RUI_RO',

  /** Utility - Tiện ích */
  UTILITY = 'utility',
  MENU_ISO = 'menu__ISO',
  MENU_KPI = 'menu__KPI',
  MENU_NEWS = 'menu__NEWS',
  MENU_KY_SO = 'menu__KY_SO',
  MENU_DANH_BA = 'menu__DANH_BA',
  MENU_PHAP_CHE = 'menu__PHAP_CHE',
  PERMISSION_UTILITY = 'permission_UTILITY',
  MENU_TIN_NHAN_NOI_BO = 'menu__TIN_NHAN_NOI_BO',
  MENU_TIN_NHAN_LIEN_THONG = 'menu__TIN_NHAN_LIEN_THONG',

  /** Report - Báo cáo */
  REPORT = 'report',

  /** Admin System - Quản trị hệ thống */
  ADMIN_SYSTEM = 'admin-system',
  MENU_CATEGORY_ADMIN_SYSTEM = 'menu_category__ADMIN_SYSTEM',
  ACCOUNT_ADMIN_SYSTEM = 'account__ADMIN_SYSTEM',
  PERMISSION_ADMIN_SYSTEM = 'permission__ADMIN_SYSTEM',

  /** Service - Dịch vụ */
  SERVICE = 'service',
  SERVICE_ONLINE = 'online-service',
  SERVICE_HR = 'human-resources',
  SERVICE_FINANCE = 'finance-accounting',
  SERVICE_EMAIL = 'online-service-email',
  SERVICE_VIMC_HR = 'online-service-vimc-hr',
  SERVICE_VIMC_PO = 'online-service-vimc-po',
  SERVICE_KNOWLEDGE = 'online-service-knowledge',
  SERVICE_CLOUD_FILE = 'online-service-cloud-file',
  SERVICE_CLOUD_TALK = 'online-service-cloud-talk',
  SERVICE_CLOUD_EMAIL = 'online-service-cloud-email',
  SERVICE_SMART_SYSTEM = 'online-service-smart-system',
  SERVICE_CLOUD_ACTIVITY = 'online-service-cloud-activity',
  SERVICE_CMN_EVALUATION = 'online-service-cmn-evaluation',
  SERVICE_POLICY_MEETING = 'online-service-policy-meeting',
  SERVICE_VIMC_DOCS = 'online-service-vimc-documents',
  SERVICE_VIMC_CLOUD_FILE = 'online-service-vimc-cloud-file',
  SERVICE_VIMC_CLOUD_TALK = 'online-service-vimc-cloud-talk',
  SERVICE_INTERCON_HUB = 'online-service-vimc-interconnection-hub',
}
